import React from "react";
import { MdEmail, MdPhone, MdLocationOn, MdAccessTime } from "react-icons/md";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2>Get In Touch</h2>
          <p>Ready to transform your sales? Contact HEM SALES AGENCIES today</p>
        </div>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon">
                <MdEmail />
              </div>
              <div>
                <h4>Email</h4>
                <p>info@hemsalesagencies.com</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <MdPhone />
              </div>
              <div>
                <h4>Phone</h4>
                <p>+91 9321037171</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <MdLocationOn />
              </div>
              <div>
                <h4>Address</h4>
                <p>
                  Shop No. G-27, Ground Floor, White Pearls, Adajan
                  <br />
                  Surat, Gujarat – 395009
                </p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <MdAccessTime />
              </div>
              <div>
                <h4>Business Hours</h4>
                <p>
                  Monday - Friday: 9:00 AM - 6:00 PM
                  <br />
                  Saturday: 10:00 AM - 4:00 PM
                </p>
              </div>
            </div>
          </div>
          {/* <form className="contact-form">
            <div className="form-group">
              <input type="text" placeholder="Your Full Name" required />
            </div>
            <div className="form-group">
              <input type="email" placeholder="Your Email Address" required />
            </div>
            <div className="form-group">
              <input type="tel" placeholder="Your Phone Number" />
            </div>
            <div className="form-group">
              <select required>
                <option value="">Select Service Interest</option>
                <option value="analytics">Sales Analytics & Reporting</option>
                <option value="leads">Lead Generation & Prospecting</option>
                <option value="training">Sales Training & Development</option>
                <option value="strategy">Growth Strategy & Planning</option>
              </select>
            </div>
            <div className="form-group">
              <textarea
                placeholder="Tell us about your business and how we can help"
                rows="5"
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary">
              Send Message
            </button>
          </form> */}
        </div>
      </div>
    </section>
  );
};

export default Contact;
